<template>
    <form class="container" @submit="submit">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="mw-970 mx-auto">
                    <div class="c-section">
                        <div class="d-flex align-items-center justify-content-between">
                            <h2 class="c-ttl c-ttl--mdp fw-b">
                                Passengers details
                            </h2>
                        </div>

                        <section class="o-bk-box box-sh bg-white is-rounded mt-4" v-for="(passenger, passengerIndex) in passengers" v-bind:key="passengerIndex" :id="'passenger_'+passengerIndex">
                            <div class="o-bk-box__title d-flex align-items-center">
                                <span class="icon-person is-square-icon is-rounded bg-sec-light-hover cl-sec-l"></span>
                                <h3 class="c-ttl c-ttl--mdp ml-3">Passenger {{ passengerIndex + 1 }}
                                    <span class="cl-sec-l fw-r ml-3">{{ passengerCategories[passenger.category] }}</span>
                                </h3>
                            </div>

                            <div class="cl-dark pr-lg-5">
                                <p class="mt-3 mb-4">
                                    Complete the passenger information as indicated on the travel documents you will use.
                                </p>

                                <div class="o-bk-form-row">
                                    <div class="o-bk-form-row__item">
                                        <div class="form-group">
                                            <label class="mb-1 fw-r d-block" :for="'passenger-name-'+passengerIndex">Name</label>
                                            <input
                                                :id="'passenger-name-'+passengerIndex"
                                                class="form-control txt-upper"
                                                type="text"
                                                required
                                                :value="passenger.name"
                                                autocomplete="given-name"
                                                @change="updatePassengerDetails(
                                                    passengerIndex,
                                                    'name',
                                                    $event.target.value.toUpperCase()
                                                )" />
                                        </div>
                                    </div>

                                    <div class="o-bk-form-row__item">
                                        <div class="form-group">
                                            <label class="mb-1 fw-r d-block" :for="'passenger-surname-'+passengerIndex">Surname</label>
                                            <input
                                                :id="'passenger-surname-'+passengerIndex"
                                                class="form-control txt-upper" 
                                                type="text"
                                                required
                                                :value="passenger.surname"
                                                autocomplete="family-name"
                                                @change="updatePassengerDetails(
                                                    passengerIndex,
                                                    'surname',
                                                    $event.target.value.toUpperCase()
                                                )" />
                                        </div>
                                    </div>

                                    <div class="o-bk-form-row__item is-xs">
                                        <div class="form-group">
                                            <label class="mb-1 fw-r d-block" :for="'passenger-gender-'+passengerIndex">Gender</label>

                                            <select
                                                :id="'passenger-gender-'+passengerIndex"
                                                class="form-control custom-select"
                                                required
                                                autocomplete="sex"
                                                :value="passenger.gender"
                                                @change="updatePassengerDetails(
                                                    passengerIndex,
                                                    'gender',
                                                    $event.target.value
                                                )"
                                            >
                                                <option></option>
                                                <option
                                                    :value="option.key"
                                                    v-for="option in genderOptions"
                                                    v-bind:key="option.key"
                                                >{{option.label}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="o-bk-form-row__item is-sm">
                                        <div class="form-group">
                                            <label class="mb-1 fw-r d-block" :for="'passenger-dob-'+passengerIndex">Date of birth</label>
                                            <datepicker
                                                @show="scrollTo('#passenger_'+passengerIndex)"
                                                :id="'passenger-dob-'+passengerIndex"
                                                required
                                                minDate="01/01/1900"
                                                :maxDate="$moment().format('DD/MM/YYYY')"
                                                title="Select date of birth"
                                                :value="passenger.dateOfBirth"
                                                @input="updatePassengerDetails(
                                                    passengerIndex,
                                                    'dateOfBirth',
                                                    $event
                                                )" />
                                        </div>
                                    </div>
                                </div>

                                <div class="o-bk-form-row">
                                    <div class="o-bk-form-row__item is-md">
                                        <div class="form-group">
                                            <label class="mb-1 fw-r d-block" :for="'passenger-nationality-'+passengerIndex">Country of nationality</label>

                                            <select
                                                :id="'passenger-nationality-'+passengerIndex"
                                                class="form-control custom-select"
                                                required
                                                :value="passenger.nationality"
                                                @change="updatePassengerDetails(
                                                    passengerIndex,
                                                    'nationality',
                                                    $event.target.value,
                                                )"    
                                            >
                                                <option></option>
                                                <option
                                                    v-for="option in nationalityOptions"
                                                    v-bind:key="option.key"
                                                    :value="option.key"
                                                >{{ option.label }}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="o-bk-form-row__item is-md">
                                        <div class="form-group">
                                            <label class="mb-1 fw-r d-block" :for="'passenger-doctype-'+passengerIndex">Document type</label>
                                            <select
                                                :id="'passenger-doctype-'+passengerIndex"
                                                class="form-control custom-select"
                                                required
                                                :value="passenger.documentType"
                                                @change="updatePassengerDetails(
                                                    passengerIndex,
                                                    'documentType',
                                                    $event.target.value,
                                                )"
                                            >
                                                <option></option>
                                                <option
                                                    v-for="option in documentTypeOptions"
                                                    v-bind:key="option.key"
                                                    :value="option.key"
                                                >{{ option.label }}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="o-bk-form-row__item is-md">
                                        <div class="form-group">
                                            <label class="mb-1 fw-r d-block" :for="'passenger-docnumber-'+passengerIndex">Travel document number</label>
                                            <input
                                                :id="'passenger-docnumber-'+passengerIndex"
                                                class="form-control"
                                                type="text"
                                                required
                                                :value="passenger.documentNumber"
                                                @change="updatePassengerDetails(
                                                    passengerIndex,
                                                    'documentNumber',
                                                    $event.target.value
                                                )" />
                                        </div>
                                    </div>
                                </div>

                                <div class="o-bk-form-row visa-requirements" v-if="getRequiredVisas(passenger.nationality).length">
                                    <div class="o-bk-form-row__item">
                                        <div class="form-group d-flex align-items-center fw-r">
                                            <label class="c-switch mr-3">
                                                <input class="c-switch__input" type="checkbox" :checked="passenger.hasVisa" @change="updatePassengerDetails(passengerIndex, 'hasVisa', $event.target.checked)">
                                                <span class="c-switch__slider"></span>
                                            </label>
                                            Passenger has a valid visa:&nbsp;
                                            <span class="visa-links">
                                                <a href="javascript:void(0)" v-for="visa in getRequiredVisas(passenger.nationality)" v-bind:key="visa.id" @click.prevent="showVisaInfo(visa.id)">{{ visa.title }}</a>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="o-bk-form-row">
                                    <div class="o-bk-form-row__item">
                                        <div class="form-group mb-0 d-flex align-items-center fw-r">
                                            <label class="c-switch mr-3">
                                                <input
                                                    class="c-switch__input"
                                                    type="checkbox"
                                                    value="1"
                                                    v-model="passenger.assistance"
                                                    @change="updatePassengerDetails(
                                                        passengerIndex,
                                                        'assistance',
                                                        $event.target.checked
                                                    )" />
                                                <span class="c-switch__slider"></span>
                                            </label>
                                            <span class="icon-accessible mr-2 cl-sec-l fs-20"></span>
                                            Need special assistance?
                                        </div>
                                        <div class="form-group mb-0" v-if="passenger.assistance">
                                            <div class="pt-3">
                                                <label class="mb-1 fw-r d-block" :for="'passenger-notes-'+passengerIndex">Notes</label>
                                                <textarea
                                                    class="form-control"
                                                    :id="'passenger-notes-'+passengerIndex"
                                                    :value="passenger.notes"
                                                    rows="2"
                                                    @change="updatePassengerDetails(
                                                        passengerIndex,
                                                        'notes',
                                                        $event.target.value
                                                    )"
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section class="o-bk-box box-sh bg-white is-rounded mt-4" id="contact-info">
                            <div class="o-bk-box__title d-flex align-items-center">
                                <span
                                    class="icon-book is-square-icon is-rounded bg-sec-light-hover cl-sec-l"></span>
                                <h3 class="c-ttl c-ttl--mdp ml-3">Contact info</h3>
                            </div>

                            <div class="cl-dark pr-lg-5 mt-3">
                                <!--p class="mt-3 mb-4">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                    incididunt.
                                </p-->

                                <div class="o-bk-form-row">
                                    <div class="o-bk-form-row__item is-md">
                                        <div class="form-group">
                                            <label class="mb-1 fw-r d-block" for="lead-passenger">Lead passenger</label>
                                            <select
                                                id="lead-passenger"
                                                class="form-control custom-select"
                                                required
                                                :value="leadPassenger"
                                                @change="updateLeadPassenger($event.target.value)"
                                            >
                                                <option v-for="option in leadPassengerOptions" v-bind:key="option.key" :value="option.key">{{ option.label }}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="o-bk-form-row__item is-md">
                                        <div class="form-group">
                                            <label class="mb-1 fw-r d-block" for="contact-email">Email address</label>
                                            <input id="contact-email" class="form-control" type="email" autocomplete="email" required :value="email" @change="updateEmail($event.target.value)">
                                        </div>
                                    </div>

                                    <div class="o-bk-form-row__item is-md">
                                        <div class="form-group">
                                            <label class="mb-1 fw-r d-block" for="contact-phone">Phone</label>

                                            <div class="c-phone-country">
                                                <input id="contact-phone" class="form-control" type="tel" required :value="phone" @change="updatePhone()">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="o-bk-form-row w-100">
                                    <div class="o-bk-form-row__item pt-2">
                                        <div class="form-group mb-0">
                                            <div class="c-custom-checkbox mb-3">
                                                <input id="terms" type="checkbox" :checked="termsAccepted" value="1" required @change="updateTermsAcceptedStatus($event.target.checked)">
                                                <label class="fw-r" for="terms">
                                                    I have read and accepted the
                                                    <a class="ml-1 c-link is-rev cl-sec-l" @click.prevent="showInfo('terms')">Terms and conditions</a>
                                                </label>
                                            </div>

                                            <div class="c-custom-checkbox mb-3">
                                                <input id="privacy" type="checkbox" :checked="privacyAccepted" value="1" required @change="updatePrivacyAcceptedStatus($event.target.checked)">
                                                <label class="fw-r" for="privacy">
                                                    I have read and accepted the
                                                    <a class="ml-1 c-link is-rev cl-sec-l" @click.prevent="showInfo('privacy')">Privacy notice</a>
                                                </label>
                                            </div>

                                            <!--div class="c-custom-checkbox mb-3">
                                                <input id="covid" type="checkbox" :checked="covidInfoAccepted" value="1" required @change="updateCovidInfoAcceptedStatus($event.target.checked)">
                                                <label class="fw-r" for="covid">
                                                    I have read and understood 
                                                    <a class="ml-1 c-link is-rev cl-sec-l" href="https://www.venezialines.com/info/covid-info/" target="_blank">Covid 19 travel regulations</a>
                                                </label>
                                            </div-->

                                            <div class="c-custom-checkbox mb-3">
                                                <input id="newsletter" type="checkbox" :checked="newsletter" @change="updateNewsletterStatus($event.target.checked)" value="1">
                                                <label class="fw-r" for="newsletter">
                                                    I accept to receive marketing communication by email related to Venezia Lines information and special offers
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <div class="d-md-flex align-items-center justify-content-between mt-4 pt-2">
                            <button type="button" class="btn btn-white-alt-sec bg-white is-wide mr-3 mb-3" @click="previousStep">Back</button>
                            <button type="submit" class="btn btn-primary is-wide mb-3">Continue</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal :title="modal.title" :body="modal.body" :loading="modal.loading" v-model="modal.show"></modal>
    </form>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import Datepicker from '../components/Datepicker.vue'
import countries from '../constants/countries'
import jsonp from 'jsonp'
import Modal from '../components/Modal.vue'

export default {
  components: { Datepicker, Modal },
    data() {
        return {
            passengerCategories: {
                adl: 'Adult',
                chd: 'Child',
                inf: 'Infant',
            },
            genderOptions: [
                { label: 'Male', key: 'M' },
                { label: 'Female', key: 'F' },
            ],
            nationalityOptions: countries.map(country => {
                return {
                    key: country.alpha2,
                    label: country.name
                }
            }),
            documentTypeOptions: [
                { key: 'I', label: 'Identity card' },
                { key: 'P', label: 'Passport' },
            ],
            iti: null,
            modal: {
                loading: false,
                title: '',
                body: '',
                show: false,
            }
        }
    },
    computed: {
        ...mapState('booking', [
            'passengersCount',
            'passengers',
            'leadPassenger',
            'termsAccepted',
            'privacyAccepted',
            'covidInfoAccepted',
            'newsletter',
            'email',
            'phone',
            'visaRules',
        ]),
        leadPassengerOptions() {
            let options = []
            for (let i = 0; i < this.passengersCount.adl; i ++) {
                let passenger = this.passengers[i]
                let name = (passenger.name && passenger.surname) ? passenger.name+' '+passenger.surname : 'Passenger '+(i+1)
                options.push({ label: name, key: i })
            }
            return options
        },
    },
    mounted() {
        this.track({
            event: 'passenger_details'
        })
        
        this.$scrollTo('body')

        this.iti = window.intlTelInput(document.getElementById('contact-phone'), {
            //separateDialCode: true,
            autoPlaceholder: 'off',
            nationalMode: false,
            initialCountry: 'auto',
            formatOnDisplay: false,
            utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.12/js/utils.min.js',
            geoIpLookup: function(success, failure) {
                jsonp('https://freegeoip.app/json/', null, (err, data) => {
                    if (err) {
                        console.error(err)
                    } else {
                        success(data.country_code);
                    }
                });
            },
        });
    },
    methods: {
        scrollTo(el) {
            this.$scrollTo(el, { offset: -20 })
        },
        ...mapMutations('booking', [
            'setPassengerDetails',
            'setEmail',
            'setPhone',
            'setLeadPassenger',
            'setTermsAcceptedStatus',
            'setCovidInfoAcceptedStatus',
            'setPrivacyAcceptedStatus',
            'setNewsletterStatus',
        ]),
        ...mapActions('booking', [
            'previousStep',
            'updateBooking',
        ]),
        updatePassengerDetails(index, property, value) {
            let passenger = {...this.passengers[index]}
            passenger[property] = value
            this.setPassengerDetails({ index: index, passenger: passenger })
        },
        getRequiredVisas(nationality) {
            let visas = []

            this.visaRules.forEach(rule => {
                if (rule.nationalities.includes(nationality.toUpperCase())) {
                    visas.push({
                        id: rule.id,
                        title: rule.title,
                    })
                }
            })

            return visas
        },
        updateEmail(value) {
            this.setEmail(value)
        },
        updatePhone() {
            this.setPhone(this.iti.getNumber())
        },
        updateTermsAcceptedStatus(value) {
            this.setTermsAcceptedStatus(value)
        },
        updatePrivacyAcceptedStatus(value) {
            this.setPrivacyAcceptedStatus(value)
        },
        updateCovidInfoAcceptedStatus(value) {
            this.setCovidInfoAcceptedStatus(value)
        },
        updateNewsletterStatus(value) {
            this.setNewsletterStatus(value)
        },
        updateLeadPassenger(value) {
            this.setLeadPassenger(value)
        },
        submit(e) {
            e.preventDefault()

            if (!this.termsAccepted) {
                this.$swal('Error', 'Please read and accept our terms and conditions', 'error')
                return
            }

            if (!this.privacyAccepted) {
                this.$swal('Error', 'Please read and accept our privacy policy', 'error')
                return
            }

            let visasRequired = []
            this.passengers.forEach((passenger, index) => {
                if (!passenger.hasVisa) {
                    let visas = this.getRequiredVisas(passenger.nationality)
                    if (visas.length) {
                        visasRequired.push('Passenger '+(index + 1))
                    }
                }
            })
            if (visasRequired.length) {
                this.$swal('Error', 'Please check visa requirements for the following passenger(s):'+"\n"+visasRequired.join("\n"), 'error')
                return
            }

            this.updateBooking(['passengers', 'contact'])
        },
        showInfo(section) {
            this.modal.loading = this.modal.show = true
            this.$api.info({ section: section }).then(response => {
                this.modal.title = response.title
                this.modal.body = response.text
                this.modal.loading = false
            })
        },
        showVisaInfo(id) {
            this.modal.loading = this.modal.show = true
            this.$api.visaRule({id:id}).then(response => {
                this.modal.title = response.title
                this.modal.body = response.description
                this.modal.loading = false
            })
        },
    }
}
</script>

<style scoped>
.visa-links a:before { content: ", "; display: inline; }
.visa-links a:first-child:before { content: ""; }
</style>